import React, { useState } from 'react';
import { Modal, Button, Header, List, Icon, Message } from 'semantic-ui-react';
import './PaymentResultModal.scss';

interface PaymentResultModalProps {
  BillingAndPackageSequence: any;
  runSequence: any;
  setProp: any;
  tabAdminRef: any
}

const PaymentResultModal = (props: PaymentResultModalProps) => {
  let isSuccess = props.BillingAndPackageSequence?.transactions?.paidResult?.status === "PAID"

  const onClose = () => {
    props.runSequence({
      sequence: "BillingAndPackage",
      action: "CLOSE_PAID_RESULT",
    })
   
  }
  
  return (
    <Modal
      id="PaymentResultModal"
      open={props.BillingAndPackageSequence.openPaidResultModal}
      onClose={onClose}
      size='small'
      className='payment-confirmation-modal'
    >
      <Modal.Content>
        <Icon
          name='close'
          className='close-icon'
          onClick={onClose}
          size='large'
        />

        <Header as='h2' textAlign='center' className='modal-header'>
          รายการคำสั่งซื้อ : {props.BillingAndPackageSequence?.transactions?.paidResult?.code}
          {isSuccess ?
            <span className='payment-success'>&nbsp;&nbsp;&nbsp;&nbsp;ชำระเงินเรียบร้อยแล้ว</span> :
            <span className='payment-failed'>&nbsp;&nbsp;&nbsp;&nbsp;ชำระเงินไม่สำเร็จ</span>}
        </Header>
        {isSuccess ?
          <>
            <List className='package-list' size='large'>
              {props.BillingAndPackageSequence?.transactions?.paidResult?.items?.map((item: any, index: number) => (
                <List.Item key={index} className='package-item'>
                  <List.Content>
                    <div className='package-row'>
                      <span className='package-info'>
                        {index + 1}. {item?.package?.name}&nbsp;&nbsp;&nbsp;&nbsp;({item?.package?.credit_amount} Credit)
                      </span>
                      <span className='package-quantity'>
                        จำนวน {Number(item.quantity.replace(/,/g, ''))} รายการ
                      </span>
                    </div>
                  </List.Content>
                </List.Item>
              ))}
            </List>
            <Message className='info-message'>
              <p>
                <strong>**</strong> ท่านสามารถตรวจสอบใบเสร็จรับเงินได้ที่หน้าประวัติการทำรายการ
              </p>
            </Message>

            <div className='button-container'>
              <Button
                className='check-balance-button'
                size='large'
                onClick={() => {
                   props.runSequence({
                    sequence: "BillingAndPackage",
                    action: "GO_TO_BILLING_PACKAGE",
                    tabAdminRef: props.tabAdminRef
                  })
                }}>
                ตรวจสอบยอด Credit
              </Button>
            </div>
          </>
          : <>
            <Message className='info-message'>
              <p className='payment-failed'>
                <strong>**</strong> กรุณาติดต่อธนาคารที่ท่านชำระเงิน
              </p>
            </Message>

            <div className='button-container'>
              <Button
                className='check-balance-button'
                size='large'
                onClick={() => {
                  props.runSequence({
                    sequence: "BillingAndPackage",
                    action: "GO_TO_BILLING_PACKAGE",
                  })
                }}
              >
                กลับสู่เมนู Billing & Package
              </Button>
            </div>
          </>
        }

      </Modal.Content>
    </Modal>
  );
};

export default PaymentResultModal;